import type { EcmpHeader } from '@core/channel-recognition';
import { createAction, props } from '@ngrx/store';

const ECMP_HEADER = '[ECMP Header]';

export const setEcmpHeaderAction = createAction(
  `${ECMP_HEADER} Set ECMP Header`,
  props<{ ecmpHeader: EcmpHeader }>()
);
